const cartLink_pg = document.querySelector('#glytch-cart-icon-bubble');

cartLink_pg.setAttribute('role', 'button');
cartLink_pg.setAttribute('aria-haspopup', 'dialog');

/*
cartLink_pg.addEventListener('click', function(event) {
  event.preventDefault();
  if (typeof openGokwikSideCart === 'function') {
    openGokwikSideCart();
  } else {
    console.warn('GoKwik cart not ready');
  }
});
*/

// ✅ Cart Count
function updateCartCount() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const badge = document.querySelector('.cart-count');
      if (!badge) return;

      if (cart.item_count > 0) {
        badge.textContent = cart.item_count;
        badge.style.display = 'flex';
      } else {
        badge.style.display = 'none';
      }
    })
    .catch(function(err) {
      console.warn('Cart count update failed:', err);
    });
}

updateCartCount();

document.addEventListener('click', function(e) {
  const btn = e.target.closest('button[name="add"], .add-to-cart, [data-add-to-cart], .custom-ajax-cart-btn');
  if (btn) {
    setTimeout(updateCartCount, 500);
  }
});

window.addEventListener('gokwikCartUpdate', updateCartCount);
document.addEventListener('cart:updated', updateCartCount);

setInterval(updateCartCount, 10000);